/** Extrait les adresses e-mail d'une ligne destinataires (À / Cc). */
export function extractComposeRecipientEmails(raw: string): string[] {
  const text = raw.trim().replace(/[\r\n;]+/g, ",");
  if (!text) return [];

  const parts = text.split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/);
  const out: string[] = [];

  for (const part of parts) {
    const trimmed = part.trim().replace(/^["']|["']$/g, "");
    if (!trimmed) continue;

    const angle = /<([^>]+)>/.exec(trimmed);
    if (angle?.[1] && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(angle[1].trim())) {
      out.push(angle[1].trim());
      continue;
    }

    const tokens = trimmed.split(/\s+/);
    for (const token of tokens) {
      const clean = token.replace(/^[,<>]+|[,<>]+$/g, "");
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clean)) {
        out.push(clean);
      }
    }
  }

  return [...new Set(out)];
}

export function composeRecipientsFieldValid(raw: string): boolean {
  return extractComposeRecipientEmails(raw).length > 0;
}
